import { loyaltyAccInfoConst } from '../constants/actionConstants';
import { objPendingErrorFalse } from '../constants/variableConstant';
import produce from 'immer';
const initState = {
  updateAlias: { obj: [] },
  updatePass: { obj: [] },
  agentNumber: { obj: [] },
  agentName: { obj: [] },
  changlenge: { obj: [] },
  listGroupGift: { obj: [] },
  reward: { obj: [] },
getallwithimage: { obj: [] },
  giftGroupDetail: { obj: [] },
  giftinfors: { obj: [] },
giftgroup: { obj: [] },
  questAll: { obj: [] },
  redeemtoken: { obj: [] },
  rewardDetail: { obj: [] },
  profilebyc: { obj: [] },
  transaction: { obj: [] },
  listMyGift: { obj: [] },
  pending: false,
  error: false,
};

export default (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loyaltyAccInfoConst.LOYALTY_ACC_INFO_LOYALTY_ALIAS:
        draft.updateAlias = action.payload;
        break;
      case loyaltyAccInfoConst.SEARCH_AGENT_INFO:
        draft.agentNumber = action.payload;
        break;
      case loyaltyAccInfoConst.SEARCH_AGENT_NAME:
        draft.agentName = action.payload;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_GETREDEEMTOKEN:
        draft.redeemtoken = action.payload;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_CHALLENGE:
        draft.pending = true;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_CHALLENGE_SUCCESS:
        draft.changlenge = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.STORE_GIFT_GETALL_BYGROUPCODE:
        draft.pending = true;
        break;

      case loyaltyAccInfoConst.STORE_GIFT_GETALL_BYGROUPCODE_SUCCESS:
        draft.listGroupGift = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_TRANSACTION:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_TRANSACTION_SUCCESS:
        draft.transaction = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE_SUCCESS:
        draft.getallwithimage = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_GROUPDETAIL_GIFTGROUP:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_GROUPDETAIL_GIFTGROUP_SUCCESS:
        draft.giftGroupDetail = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_REWARD:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_REWARD_SUCCESS:
        draft.reward = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_GIFTGROUP:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_GIFTGROUP_SUCCESS:
        draft.giftgroup = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_GIFTINFORS:
        draft.pending = true;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_GIFTINFORS_SUCCESS:
        draft.giftinfors = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_REWARD_DETAIL:
        draft.rewardDetail = action.payload;
        break;

      case loyaltyAccInfoConst.GET_LOYALTY_GETPROFILEBYC:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_GETPROFILEBYC_SUCCESS:
        draft.pending = false;
        draft.profilebyc = action.payload;
        break;

      case loyaltyAccInfoConst.SEARCH_AGENT_CODE:
        draft.agentNumber = action.payload;
        break;
case loyaltyAccInfoConst.GIFT_QUEST_GETALL:
        draft.pending = true;
        break;

      case loyaltyAccInfoConst.GIFT_QUEST_GETALL_SUCCESS:
        draft.pending = true;
        draft.questAll = action.payload;
        break;

      case loyaltyAccInfoConst.LOYALTY_ACC_PROFILE_MEMBER:
        draft.pending = true;
        draft.profile = action.payload;
        break;
      case loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE:
        draft.pending = true;
        break;

      case loyaltyAccInfoConst.STORE_GIFT_GETALL_BYMEMBERCODE_SUCCESS:
        const resultData3 = {
          obj: action.payload.result ?? {},
          responseMessage: "Success",
          responseStatus: 200,
          totalRecords: 1
        }
        draft.pending = true;
        draft.listMyGift = resultData3;
        break;

      case loyaltyAccInfoConst.LOYALTY_ACC_INFO_RESET_STATE:
        return initState;
      default:
        return state;
    }
  });
